import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { WkoLoadingSpinner } from "../WkoLoadingSpinner";
import { notifyError } from "../../utils/notifications";
import { BenchmarkCard } from "./BenchmarkCard";
const LEGEND_STAT = {
    RankName: "legend",
    Level1: 0,
    Level2: 0,
    Level3: 0,
    Level4: 0,
};
const MAX_BAR_WIDTH = 85;
const getBarWidth = (value, maxValue, isLegend) => {
    if (isLegend)
        return "50%";
    if (maxValue <= 0)
        return "0%";
    return `${Math.trunc((value / maxValue) * MAX_BAR_WIDTH)}%`;
};
export const RankStatsByLevelPanel = ({ options, title = "Ranks - Average non-conforming days per vessel over the selected period", }) => {
    const [loading, setLoading] = useState(true);
    const [stats, setStats] = useState([]);
    useEffect(() => {
        if (!options.isReady)
            return;
        setStats([]);
        setLoading(true);
        const query = new URLSearchParams({
            fromMonth: options.startDate.substring(0, 7),
            toMonth: options.endDate.substring(0, 7),
            fleets: options.fleet.map((fleet) => fleet.ID).join(","),
            locationId: options.locationId == null ? "" : String(options.locationId),
        }).toString();
        fetch(`/api/levelsbenchmark/rankstat?${query}`)
            .then((res) => {
            if (res.ok)
                return res.json();
            throw new Error(res.statusText);
        })
            .then((data) => {
            setStats([LEGEND_STAT, ...data]);
        })
            .catch(() => {
            notifyError("An error has occurred when loading rank stats. Please try again.");
        })
            .finally(() => setLoading(false));
    }, [
        options.isReady,
        options.startDate,
        options.endDate,
        options.fleet.map((fleet) => fleet.ID).join(","),
        options.locationId,
    ]);
    const maxValue = Math.max(0, ...stats.map((stat) => stat.Level1), ...stats.map((stat) => stat.Level2), ...stats.map((stat) => stat.Level3), ...stats.map((stat) => stat.Level4));
    return (_jsx(BenchmarkCard, { title: title, children: loading ? (_jsx(WkoLoadingSpinner, {})) : stats.length <= 1 ? (_jsx("div", { className: "py-5", children: _jsx("p", { className: "text-secondary text-center mb-0", children: "No data for this selection." }) })) : (_jsx("div", { className: "w-100", children: _jsx("div", { className: "d-flex flex-wrap row", children: stats.map((stat) => (_jsx(LevelRankStatCard, { stat: stat, maxValue: maxValue }, stat.RankName))) }) })) }));
};
const LevelRankStatCard = ({ stat, maxValue }) => {
    const isLegend = stat.RankName.toLowerCase() === "legend";
    return (_jsx("div", { className: "col-4 mb-3 pb-3", children: _jsxs("div", { children: [_jsx("h3", { children: isLegend ? stat.RankName.toLowerCase() : stat.RankName.toUpperCase() }), _jsxs("div", { children: [_jsx(RankLevelRow, { className: "shadow float-start rank-bg-level1 soft-light-overlay pb-2 ps-2", width: getBarWidth(stat.Level1, maxValue, isLegend), label: isLegend ? "NC Level 1" : "\u00a0", value: isLegend ? "\u00a0" : stat.Level1 }), _jsx(RankLevelRow, { className: "shadow float-start rank-bg-level2 soft-light-overlay pb-2 ps-2", width: getBarWidth(stat.Level2, maxValue, isLegend), label: isLegend ? "NC Level 2" : "\u00a0", value: isLegend ? "\u00a0" : stat.Level2 }), _jsx(RankLevelRow, { className: "shadow float-start rank-bg-level3 soft-light-overlay pb-2 ps-2", width: getBarWidth(stat.Level3, maxValue, isLegend), label: isLegend ? "NC Level 3" : "\u00a0", value: isLegend ? "\u00a0" : stat.Level3 }), _jsx(RankLevelRow, { className: "shadow float-start rank-bg-level4 soft-light-overlay pb-2 ps-2", width: getBarWidth(stat.Level4, maxValue, isLegend), label: isLegend ? "NC Level 4" : "\u00a0", value: isLegend ? "\u00a0" : stat.Level4 })] })] }) }));
};
const RankLevelRow = ({ className, width, label, value, }) => {
    return (_jsxs("div", { style: { clear: "both" }, children: [_jsx("div", { className: className, style: { width, height: "1.25rem" }, children: label }), _jsx("div", { className: "float-start pb-2 ps-2", style: { height: "1.25rem" }, children: value })] }));
};
